import { render, staticRenderFns } from "./AppealsTable.vue?vue&type=template&id=46b0fcfb&"
import script from "./AppealsTable.vue?vue&type=script&lang=js&"
export * from "./AppealsTable.vue?vue&type=script&lang=js&"
import style0 from "./AppealsTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports